"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/projects/v1/projects.proto
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectsServiceClient = exports.EnrichSalesforceDataOrganizationEvent = exports.FetchProjectResponse = exports.FetchProjectRequest = exports.Asset = exports.CommitmentPartner = exports.PartnerLogo = exports.Organization = exports.Reservation = exports.ProjectAggregate = exports.Label = exports.LabelGroup = exports.Owner = exports.Reward = exports.Description = exports.CollectStep = exports.Collect = exports.SalesforceData = exports.Project = void 0;
/* eslint-disable */
var collect_1 = require("../../common/v1/collect");
var financial_rank_1 = require("../../common/v1/financial_rank");
var health_1 = require("../../common/v1/health");
var product_kind_1 = require("../../common/v1/product_kind");
var project_risk_category_1 = require("../../common/v1/project_risk_category");
var reservation_1 = require("../../common/v1/reservation");
var shipping_mode_1 = require("../../common/v1/shipping_mode");
var term_frequency_1 = require("../../common/v1/term_frequency");
function createBaseProject() {
    return {
        title: "",
        state: "",
        category: "",
        teasing: false,
        id: 0,
        articles_count: 0,
        comments_count: 0,
        slug: "",
        salesforce_data: undefined,
    };
}
exports.Project = {
    fromJSON: function (object) {
        return {
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            state: isSet(object.state) ? globalThis.String(object.state) : "",
            category: isSet(object.category) ? globalThis.String(object.category) : "",
            teasing: isSet(object.teasing) ? globalThis.Boolean(object.teasing) : false,
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            articles_count: isSet(object.articles_count) ? globalThis.Number(object.articles_count) : 0,
            comments_count: isSet(object.comments_count) ? globalThis.Number(object.comments_count) : 0,
            slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
            salesforce_data: isSet(object.salesforce_data) ? exports.SalesforceData.fromJSON(object.salesforce_data) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.state !== "") {
            obj.state = message.state;
        }
        if (message.category !== "") {
            obj.category = message.category;
        }
        if (message.teasing !== false) {
            obj.teasing = message.teasing;
        }
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.articles_count !== 0) {
            obj.articles_count = Math.round(message.articles_count);
        }
        if (message.comments_count !== 0) {
            obj.comments_count = Math.round(message.comments_count);
        }
        if (message.slug !== "") {
            obj.slug = message.slug;
        }
        if (message.salesforce_data !== undefined) {
            obj.salesforce_data = exports.SalesforceData.toJSON(message.salesforce_data);
        }
        return obj;
    },
    create: function (base) {
        return exports.Project.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var message = createBaseProject();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.state = (_b = object.state) !== null && _b !== void 0 ? _b : "";
        message.category = (_c = object.category) !== null && _c !== void 0 ? _c : "";
        message.teasing = (_d = object.teasing) !== null && _d !== void 0 ? _d : false;
        message.id = (_e = object.id) !== null && _e !== void 0 ? _e : 0;
        message.articles_count = (_f = object.articles_count) !== null && _f !== void 0 ? _f : 0;
        message.comments_count = (_g = object.comments_count) !== null && _g !== void 0 ? _g : 0;
        message.slug = (_h = object.slug) !== null && _h !== void 0 ? _h : "";
        message.salesforce_data = (object.salesforce_data !== undefined && object.salesforce_data !== null)
            ? exports.SalesforceData.fromPartial(object.salesforce_data)
            : undefined;
        return message;
    },
};
function createBaseSalesforceData() {
    return { project_type: "", project: "", jobs: 0, total_area_in_hectare: 0, household_equivalent: 0 };
}
exports.SalesforceData = {
    fromJSON: function (object) {
        return {
            project_type: isSet(object.project_type) ? globalThis.String(object.project_type) : "",
            project: isSet(object.project) ? globalThis.String(object.project) : "",
            jobs: isSet(object.jobs) ? globalThis.Number(object.jobs) : 0,
            total_area_in_hectare: isSet(object.total_area_in_hectare) ? globalThis.Number(object.total_area_in_hectare) : 0,
            household_equivalent: isSet(object.household_equivalent) ? globalThis.Number(object.household_equivalent) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.project_type !== "") {
            obj.project_type = message.project_type;
        }
        if (message.project !== "") {
            obj.project = message.project;
        }
        if (message.jobs !== 0) {
            obj.jobs = Math.round(message.jobs);
        }
        if (message.total_area_in_hectare !== 0) {
            obj.total_area_in_hectare = Math.round(message.total_area_in_hectare);
        }
        if (message.household_equivalent !== 0) {
            obj.household_equivalent = Math.round(message.household_equivalent);
        }
        return obj;
    },
    create: function (base) {
        return exports.SalesforceData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e;
        var message = createBaseSalesforceData();
        message.project_type = (_a = object.project_type) !== null && _a !== void 0 ? _a : "";
        message.project = (_b = object.project) !== null && _b !== void 0 ? _b : "";
        message.jobs = (_c = object.jobs) !== null && _c !== void 0 ? _c : 0;
        message.total_area_in_hectare = (_d = object.total_area_in_hectare) !== null && _d !== void 0 ? _d : 0;
        message.household_equivalent = (_e = object.household_equivalent) !== null && _e !== void 0 ? _e : 0;
        return message;
    },
};
function createBaseCollect() {
    return {
        type: collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED,
        goal_type: collect_1.CollectGoalType.COLLECT_GOAL_TYPE_UNSPECIFIED,
        is_cip: false,
        progress: 0,
        collected_amount: 0,
        collected_quantity: 0,
        goal_amount: 0,
        goal_quantity: 0,
        interests_ratio: 0,
        ends_at: "",
        professional_amount: 0,
        term_frequency: undefined,
        term_quantity: undefined,
        amortization_delay: undefined,
        repayment_delay: undefined,
        financial_rank: undefined,
        min_pledge_amount: 0,
        dir_file_name: undefined,
        id: 0,
        success_trigger_ratio: 0,
        collect_steps: [],
    };
}
exports.Collect = {
    fromJSON: function (object) {
        return {
            type: isSet(object.type) ? (0, collect_1.collectTypeFromJSON)(object.type) : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED,
            goal_type: isSet(object.goal_type)
                ? (0, collect_1.collectGoalTypeFromJSON)(object.goal_type)
                : collect_1.CollectGoalType.COLLECT_GOAL_TYPE_UNSPECIFIED,
            is_cip: isSet(object.is_cip) ? globalThis.Boolean(object.is_cip) : false,
            progress: isSet(object.progress) ? globalThis.Number(object.progress) : 0,
            collected_amount: isSet(object.collected_amount) ? globalThis.Number(object.collected_amount) : 0,
            collected_quantity: isSet(object.collected_quantity) ? globalThis.Number(object.collected_quantity) : 0,
            goal_amount: isSet(object.goal_amount) ? globalThis.Number(object.goal_amount) : 0,
            goal_quantity: isSet(object.goal_quantity) ? globalThis.Number(object.goal_quantity) : 0,
            interests_ratio: isSet(object.interests_ratio) ? globalThis.Number(object.interests_ratio) : 0,
            ends_at: isSet(object.ends_at) ? globalThis.String(object.ends_at) : "",
            professional_amount: isSet(object.professional_amount) ? globalThis.Number(object.professional_amount) : 0,
            term_frequency: isSet(object.term_frequency) ? (0, term_frequency_1.termFrequencyFromJSON)(object.term_frequency) : undefined,
            term_quantity: isSet(object.term_quantity) ? globalThis.Number(object.term_quantity) : undefined,
            amortization_delay: isSet(object.amortization_delay) ? globalThis.Number(object.amortization_delay) : undefined,
            repayment_delay: isSet(object.repayment_delay) ? globalThis.Number(object.repayment_delay) : undefined,
            financial_rank: isSet(object.financial_rank) ? (0, financial_rank_1.financialRankFromJSON)(object.financial_rank) : undefined,
            min_pledge_amount: isSet(object.min_pledge_amount) ? globalThis.Number(object.min_pledge_amount) : 0,
            dir_file_name: isSet(object.dir_file_name) ? globalThis.String(object.dir_file_name) : undefined,
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            success_trigger_ratio: isSet(object.success_trigger_ratio) ? globalThis.Number(object.success_trigger_ratio) : 0,
            collect_steps: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.collect_steps)
                ? object.collect_steps.map(function (e) { return exports.CollectStep.fromJSON(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.type !== collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED) {
            obj.type = (0, collect_1.collectTypeToJSON)(message.type);
        }
        if (message.goal_type !== collect_1.CollectGoalType.COLLECT_GOAL_TYPE_UNSPECIFIED) {
            obj.goal_type = (0, collect_1.collectGoalTypeToJSON)(message.goal_type);
        }
        if (message.is_cip !== false) {
            obj.is_cip = message.is_cip;
        }
        if (message.progress !== 0) {
            obj.progress = Math.round(message.progress);
        }
        if (message.collected_amount !== 0) {
            obj.collected_amount = Math.round(message.collected_amount);
        }
        if (message.collected_quantity !== 0) {
            obj.collected_quantity = Math.round(message.collected_quantity);
        }
        if (message.goal_amount !== 0) {
            obj.goal_amount = Math.round(message.goal_amount);
        }
        if (message.goal_quantity !== 0) {
            obj.goal_quantity = Math.round(message.goal_quantity);
        }
        if (message.interests_ratio !== 0) {
            obj.interests_ratio = message.interests_ratio;
        }
        if (message.ends_at !== "") {
            obj.ends_at = message.ends_at;
        }
        if (message.professional_amount !== 0) {
            obj.professional_amount = Math.round(message.professional_amount);
        }
        if (message.term_frequency !== undefined) {
            obj.term_frequency = (0, term_frequency_1.termFrequencyToJSON)(message.term_frequency);
        }
        if (message.term_quantity !== undefined) {
            obj.term_quantity = Math.round(message.term_quantity);
        }
        if (message.amortization_delay !== undefined) {
            obj.amortization_delay = Math.round(message.amortization_delay);
        }
        if (message.repayment_delay !== undefined) {
            obj.repayment_delay = Math.round(message.repayment_delay);
        }
        if (message.financial_rank !== undefined) {
            obj.financial_rank = (0, financial_rank_1.financialRankToJSON)(message.financial_rank);
        }
        if (message.min_pledge_amount !== 0) {
            obj.min_pledge_amount = Math.round(message.min_pledge_amount);
        }
        if (message.dir_file_name !== undefined) {
            obj.dir_file_name = message.dir_file_name;
        }
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.success_trigger_ratio !== 0) {
            obj.success_trigger_ratio = message.success_trigger_ratio;
        }
        if ((_a = message.collect_steps) === null || _a === void 0 ? void 0 : _a.length) {
            obj.collect_steps = message.collect_steps.map(function (e) { return exports.CollectStep.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.Collect.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        var message = createBaseCollect();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED;
        message.goal_type = (_b = object.goal_type) !== null && _b !== void 0 ? _b : collect_1.CollectGoalType.COLLECT_GOAL_TYPE_UNSPECIFIED;
        message.is_cip = (_c = object.is_cip) !== null && _c !== void 0 ? _c : false;
        message.progress = (_d = object.progress) !== null && _d !== void 0 ? _d : 0;
        message.collected_amount = (_e = object.collected_amount) !== null && _e !== void 0 ? _e : 0;
        message.collected_quantity = (_f = object.collected_quantity) !== null && _f !== void 0 ? _f : 0;
        message.goal_amount = (_g = object.goal_amount) !== null && _g !== void 0 ? _g : 0;
        message.goal_quantity = (_h = object.goal_quantity) !== null && _h !== void 0 ? _h : 0;
        message.interests_ratio = (_j = object.interests_ratio) !== null && _j !== void 0 ? _j : 0;
        message.ends_at = (_k = object.ends_at) !== null && _k !== void 0 ? _k : "";
        message.professional_amount = (_l = object.professional_amount) !== null && _l !== void 0 ? _l : 0;
        message.term_frequency = (_m = object.term_frequency) !== null && _m !== void 0 ? _m : undefined;
        message.term_quantity = (_o = object.term_quantity) !== null && _o !== void 0 ? _o : undefined;
        message.amortization_delay = (_p = object.amortization_delay) !== null && _p !== void 0 ? _p : undefined;
        message.repayment_delay = (_q = object.repayment_delay) !== null && _q !== void 0 ? _q : undefined;
        message.financial_rank = (_r = object.financial_rank) !== null && _r !== void 0 ? _r : undefined;
        message.min_pledge_amount = (_s = object.min_pledge_amount) !== null && _s !== void 0 ? _s : 0;
        message.dir_file_name = (_t = object.dir_file_name) !== null && _t !== void 0 ? _t : undefined;
        message.id = (_u = object.id) !== null && _u !== void 0 ? _u : 0;
        message.success_trigger_ratio = (_v = object.success_trigger_ratio) !== null && _v !== void 0 ? _v : 0;
        message.collect_steps = ((_w = object.collect_steps) === null || _w === void 0 ? void 0 : _w.map(function (e) { return exports.CollectStep.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseCollectStep() {
    return { amount: 0, description: "", created_at: "", updated_at: "" };
}
exports.CollectStep = {
    fromJSON: function (object) {
        return {
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
            updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.created_at !== "") {
            obj.created_at = message.created_at;
        }
        if (message.updated_at !== "") {
            obj.updated_at = message.updated_at;
        }
        return obj;
    },
    create: function (base) {
        return exports.CollectStep.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseCollectStep();
        message.amount = (_a = object.amount) !== null && _a !== void 0 ? _a : 0;
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.created_at = (_c = object.created_at) !== null && _c !== void 0 ? _c : "";
        message.updated_at = (_d = object.updated_at) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseDescription() {
    return {
        short_description: "",
        description: "",
        usage_description: "",
        place: "",
        owner_name: "",
        image_file_name: undefined,
        financial_analysis: undefined,
        pnl: undefined,
        balance: undefined,
        inc_exp: undefined,
        financial_introduction: undefined,
        risks_list: undefined,
        benefits_list: undefined,
        fees_list: undefined,
        video_url: undefined,
        facebook_url: undefined,
        instagram_url: undefined,
        twitter_url: undefined,
        linkedin_url: undefined,
        website_url: undefined,
        risk_category: project_risk_category_1.ProjectRiskCategory.PROJECT_RISK_CATEGORY_UNSPECIFIED,
        impact_jobs: undefined,
        impact_surface: undefined,
        impact_home: undefined,
        guarantee_desc: undefined,
        deposit_amount: undefined,
        equity_amount: undefined,
        mezzanine_amount: undefined,
        bank_loan_amount: undefined,
        grant_amount: undefined,
        self_financing_amount: undefined,
        other_funding_amount: undefined,
        total_funding_amount: 0,
    };
}
exports.Description = {
    fromJSON: function (object) {
        return {
            short_description: isSet(object.short_description) ? globalThis.String(object.short_description) : "",
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            usage_description: isSet(object.usage_description) ? globalThis.String(object.usage_description) : "",
            place: isSet(object.place) ? globalThis.String(object.place) : "",
            owner_name: isSet(object.owner_name) ? globalThis.String(object.owner_name) : "",
            image_file_name: isSet(object.image_file_name) ? globalThis.String(object.image_file_name) : undefined,
            financial_analysis: isSet(object.financial_analysis) ? globalThis.String(object.financial_analysis) : undefined,
            pnl: isSet(object.pnl) ? globalThis.String(object.pnl) : undefined,
            balance: isSet(object.balance) ? globalThis.String(object.balance) : undefined,
            inc_exp: isSet(object.inc_exp) ? globalThis.String(object.inc_exp) : undefined,
            financial_introduction: isSet(object.financial_introduction)
                ? globalThis.String(object.financial_introduction)
                : undefined,
            risks_list: isSet(object.risks_list) ? globalThis.String(object.risks_list) : undefined,
            benefits_list: isSet(object.benefits_list) ? globalThis.String(object.benefits_list) : undefined,
            fees_list: isSet(object.fees_list) ? globalThis.String(object.fees_list) : undefined,
            video_url: isSet(object.video_url) ? globalThis.String(object.video_url) : undefined,
            facebook_url: isSet(object.facebook_url) ? globalThis.String(object.facebook_url) : undefined,
            instagram_url: isSet(object.instagram_url) ? globalThis.String(object.instagram_url) : undefined,
            twitter_url: isSet(object.twitter_url) ? globalThis.String(object.twitter_url) : undefined,
            linkedin_url: isSet(object.linkedin_url) ? globalThis.String(object.linkedin_url) : undefined,
            website_url: isSet(object.website_url) ? globalThis.String(object.website_url) : undefined,
            risk_category: isSet(object.risk_category)
                ? (0, project_risk_category_1.projectRiskCategoryFromJSON)(object.risk_category)
                : project_risk_category_1.ProjectRiskCategory.PROJECT_RISK_CATEGORY_UNSPECIFIED,
            impact_jobs: isSet(object.impact_jobs) ? globalThis.Number(object.impact_jobs) : undefined,
            impact_surface: isSet(object.impact_surface) ? globalThis.Number(object.impact_surface) : undefined,
            impact_home: isSet(object.impact_home) ? globalThis.Number(object.impact_home) : undefined,
            guarantee_desc: isSet(object.guarantee_desc) ? globalThis.String(object.guarantee_desc) : undefined,
            deposit_amount: isSet(object.deposit_amount) ? globalThis.Number(object.deposit_amount) : undefined,
            equity_amount: isSet(object.equity_amount) ? globalThis.Number(object.equity_amount) : undefined,
            mezzanine_amount: isSet(object.mezzanine_amount) ? globalThis.Number(object.mezzanine_amount) : undefined,
            bank_loan_amount: isSet(object.bank_loan_amount) ? globalThis.Number(object.bank_loan_amount) : undefined,
            grant_amount: isSet(object.grant_amount) ? globalThis.Number(object.grant_amount) : undefined,
            self_financing_amount: isSet(object.self_financing_amount)
                ? globalThis.Number(object.self_financing_amount)
                : undefined,
            other_funding_amount: isSet(object.other_funding_amount)
                ? globalThis.Number(object.other_funding_amount)
                : undefined,
            total_funding_amount: isSet(object.total_funding_amount) ? globalThis.Number(object.total_funding_amount) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.short_description !== "") {
            obj.short_description = message.short_description;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.usage_description !== "") {
            obj.usage_description = message.usage_description;
        }
        if (message.place !== "") {
            obj.place = message.place;
        }
        if (message.owner_name !== "") {
            obj.owner_name = message.owner_name;
        }
        if (message.image_file_name !== undefined) {
            obj.image_file_name = message.image_file_name;
        }
        if (message.financial_analysis !== undefined) {
            obj.financial_analysis = message.financial_analysis;
        }
        if (message.pnl !== undefined) {
            obj.pnl = message.pnl;
        }
        if (message.balance !== undefined) {
            obj.balance = message.balance;
        }
        if (message.inc_exp !== undefined) {
            obj.inc_exp = message.inc_exp;
        }
        if (message.financial_introduction !== undefined) {
            obj.financial_introduction = message.financial_introduction;
        }
        if (message.risks_list !== undefined) {
            obj.risks_list = message.risks_list;
        }
        if (message.benefits_list !== undefined) {
            obj.benefits_list = message.benefits_list;
        }
        if (message.fees_list !== undefined) {
            obj.fees_list = message.fees_list;
        }
        if (message.video_url !== undefined) {
            obj.video_url = message.video_url;
        }
        if (message.facebook_url !== undefined) {
            obj.facebook_url = message.facebook_url;
        }
        if (message.instagram_url !== undefined) {
            obj.instagram_url = message.instagram_url;
        }
        if (message.twitter_url !== undefined) {
            obj.twitter_url = message.twitter_url;
        }
        if (message.linkedin_url !== undefined) {
            obj.linkedin_url = message.linkedin_url;
        }
        if (message.website_url !== undefined) {
            obj.website_url = message.website_url;
        }
        if (message.risk_category !== project_risk_category_1.ProjectRiskCategory.PROJECT_RISK_CATEGORY_UNSPECIFIED) {
            obj.risk_category = (0, project_risk_category_1.projectRiskCategoryToJSON)(message.risk_category);
        }
        if (message.impact_jobs !== undefined) {
            obj.impact_jobs = Math.round(message.impact_jobs);
        }
        if (message.impact_surface !== undefined) {
            obj.impact_surface = Math.round(message.impact_surface);
        }
        if (message.impact_home !== undefined) {
            obj.impact_home = Math.round(message.impact_home);
        }
        if (message.guarantee_desc !== undefined) {
            obj.guarantee_desc = message.guarantee_desc;
        }
        if (message.deposit_amount !== undefined) {
            obj.deposit_amount = Math.round(message.deposit_amount);
        }
        if (message.equity_amount !== undefined) {
            obj.equity_amount = Math.round(message.equity_amount);
        }
        if (message.mezzanine_amount !== undefined) {
            obj.mezzanine_amount = Math.round(message.mezzanine_amount);
        }
        if (message.bank_loan_amount !== undefined) {
            obj.bank_loan_amount = Math.round(message.bank_loan_amount);
        }
        if (message.grant_amount !== undefined) {
            obj.grant_amount = Math.round(message.grant_amount);
        }
        if (message.self_financing_amount !== undefined) {
            obj.self_financing_amount = Math.round(message.self_financing_amount);
        }
        if (message.other_funding_amount !== undefined) {
            obj.other_funding_amount = Math.round(message.other_funding_amount);
        }
        if (message.total_funding_amount !== 0) {
            obj.total_funding_amount = Math.round(message.total_funding_amount);
        }
        return obj;
    },
    create: function (base) {
        return exports.Description.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
        var message = createBaseDescription();
        message.short_description = (_a = object.short_description) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.usage_description = (_c = object.usage_description) !== null && _c !== void 0 ? _c : "";
        message.place = (_d = object.place) !== null && _d !== void 0 ? _d : "";
        message.owner_name = (_e = object.owner_name) !== null && _e !== void 0 ? _e : "";
        message.image_file_name = (_f = object.image_file_name) !== null && _f !== void 0 ? _f : undefined;
        message.financial_analysis = (_g = object.financial_analysis) !== null && _g !== void 0 ? _g : undefined;
        message.pnl = (_h = object.pnl) !== null && _h !== void 0 ? _h : undefined;
        message.balance = (_j = object.balance) !== null && _j !== void 0 ? _j : undefined;
        message.inc_exp = (_k = object.inc_exp) !== null && _k !== void 0 ? _k : undefined;
        message.financial_introduction = (_l = object.financial_introduction) !== null && _l !== void 0 ? _l : undefined;
        message.risks_list = (_m = object.risks_list) !== null && _m !== void 0 ? _m : undefined;
        message.benefits_list = (_o = object.benefits_list) !== null && _o !== void 0 ? _o : undefined;
        message.fees_list = (_p = object.fees_list) !== null && _p !== void 0 ? _p : undefined;
        message.video_url = (_q = object.video_url) !== null && _q !== void 0 ? _q : undefined;
        message.facebook_url = (_r = object.facebook_url) !== null && _r !== void 0 ? _r : undefined;
        message.instagram_url = (_s = object.instagram_url) !== null && _s !== void 0 ? _s : undefined;
        message.twitter_url = (_t = object.twitter_url) !== null && _t !== void 0 ? _t : undefined;
        message.linkedin_url = (_u = object.linkedin_url) !== null && _u !== void 0 ? _u : undefined;
        message.website_url = (_v = object.website_url) !== null && _v !== void 0 ? _v : undefined;
        message.risk_category = (_w = object.risk_category) !== null && _w !== void 0 ? _w : project_risk_category_1.ProjectRiskCategory.PROJECT_RISK_CATEGORY_UNSPECIFIED;
        message.impact_jobs = (_x = object.impact_jobs) !== null && _x !== void 0 ? _x : undefined;
        message.impact_surface = (_y = object.impact_surface) !== null && _y !== void 0 ? _y : undefined;
        message.impact_home = (_z = object.impact_home) !== null && _z !== void 0 ? _z : undefined;
        message.guarantee_desc = (_0 = object.guarantee_desc) !== null && _0 !== void 0 ? _0 : undefined;
        message.deposit_amount = (_1 = object.deposit_amount) !== null && _1 !== void 0 ? _1 : undefined;
        message.equity_amount = (_2 = object.equity_amount) !== null && _2 !== void 0 ? _2 : undefined;
        message.mezzanine_amount = (_3 = object.mezzanine_amount) !== null && _3 !== void 0 ? _3 : undefined;
        message.bank_loan_amount = (_4 = object.bank_loan_amount) !== null && _4 !== void 0 ? _4 : undefined;
        message.grant_amount = (_5 = object.grant_amount) !== null && _5 !== void 0 ? _5 : undefined;
        message.self_financing_amount = (_6 = object.self_financing_amount) !== null && _6 !== void 0 ? _6 : undefined;
        message.other_funding_amount = (_7 = object.other_funding_amount) !== null && _7 !== void 0 ? _7 : undefined;
        message.total_funding_amount = (_8 = object.total_funding_amount) !== null && _8 !== void 0 ? _8 : 0;
        return message;
    },
};
function createBaseReward() {
    return {
        amount: 0,
        quantity: 0,
        description: "",
        pledges_count: 0,
        available_quantity: 0,
        delivery_at: "",
        image_file_name: "",
        id: 0,
        title: "",
        shipping_mode: shipping_mode_1.ShippingMode.SHIPPING_MODE_UNSPECIFIED,
        shipping_details: "",
        star: false,
        taken_quantity: 0,
        is_available: false,
    };
}
exports.Reward = {
    fromJSON: function (object) {
        return {
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
            quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            pledges_count: isSet(object.pledges_count) ? globalThis.Number(object.pledges_count) : 0,
            available_quantity: isSet(object.available_quantity) ? globalThis.Number(object.available_quantity) : 0,
            delivery_at: isSet(object.delivery_at) ? globalThis.String(object.delivery_at) : "",
            image_file_name: isSet(object.image_file_name) ? globalThis.String(object.image_file_name) : "",
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            shipping_mode: isSet(object.shipping_mode)
                ? (0, shipping_mode_1.shippingModeFromJSON)(object.shipping_mode)
                : shipping_mode_1.ShippingMode.SHIPPING_MODE_UNSPECIFIED,
            shipping_details: isSet(object.shipping_details) ? globalThis.String(object.shipping_details) : "",
            star: isSet(object.star) ? globalThis.Boolean(object.star) : false,
            taken_quantity: isSet(object.taken_quantity) ? globalThis.Number(object.taken_quantity) : 0,
            is_available: isSet(object.is_available) ? globalThis.Boolean(object.is_available) : false,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        if (message.quantity !== 0) {
            obj.quantity = Math.round(message.quantity);
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.pledges_count !== 0) {
            obj.pledges_count = Math.round(message.pledges_count);
        }
        if (message.available_quantity !== 0) {
            obj.available_quantity = Math.round(message.available_quantity);
        }
        if (message.delivery_at !== "") {
            obj.delivery_at = message.delivery_at;
        }
        if (message.image_file_name !== "") {
            obj.image_file_name = message.image_file_name;
        }
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.shipping_mode !== shipping_mode_1.ShippingMode.SHIPPING_MODE_UNSPECIFIED) {
            obj.shipping_mode = (0, shipping_mode_1.shippingModeToJSON)(message.shipping_mode);
        }
        if (message.shipping_details !== "") {
            obj.shipping_details = message.shipping_details;
        }
        if (message.star !== false) {
            obj.star = message.star;
        }
        if (message.taken_quantity !== 0) {
            obj.taken_quantity = Math.round(message.taken_quantity);
        }
        if (message.is_available !== false) {
            obj.is_available = message.is_available;
        }
        return obj;
    },
    create: function (base) {
        return exports.Reward.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var message = createBaseReward();
        message.amount = (_a = object.amount) !== null && _a !== void 0 ? _a : 0;
        message.quantity = (_b = object.quantity) !== null && _b !== void 0 ? _b : 0;
        message.description = (_c = object.description) !== null && _c !== void 0 ? _c : "";
        message.pledges_count = (_d = object.pledges_count) !== null && _d !== void 0 ? _d : 0;
        message.available_quantity = (_e = object.available_quantity) !== null && _e !== void 0 ? _e : 0;
        message.delivery_at = (_f = object.delivery_at) !== null && _f !== void 0 ? _f : "";
        message.image_file_name = (_g = object.image_file_name) !== null && _g !== void 0 ? _g : "";
        message.id = (_h = object.id) !== null && _h !== void 0 ? _h : 0;
        message.title = (_j = object.title) !== null && _j !== void 0 ? _j : "";
        message.shipping_mode = (_k = object.shipping_mode) !== null && _k !== void 0 ? _k : shipping_mode_1.ShippingMode.SHIPPING_MODE_UNSPECIFIED;
        message.shipping_details = (_l = object.shipping_details) !== null && _l !== void 0 ? _l : "";
        message.star = (_m = object.star) !== null && _m !== void 0 ? _m : false;
        message.taken_quantity = (_o = object.taken_quantity) !== null && _o !== void 0 ? _o : 0;
        message.is_available = (_p = object.is_available) !== null && _p !== void 0 ? _p : false;
        return message;
    },
};
function createBaseOwner() {
    return { full_name: "", avatar_file_name: undefined, id: 0 };
}
exports.Owner = {
    fromJSON: function (object) {
        return {
            full_name: isSet(object.full_name) ? globalThis.String(object.full_name) : "",
            avatar_file_name: isSet(object.avatar_file_name) ? globalThis.String(object.avatar_file_name) : undefined,
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.full_name !== "") {
            obj.full_name = message.full_name;
        }
        if (message.avatar_file_name !== undefined) {
            obj.avatar_file_name = message.avatar_file_name;
        }
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        return obj;
    },
    create: function (base) {
        return exports.Owner.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseOwner();
        message.full_name = (_a = object.full_name) !== null && _a !== void 0 ? _a : "";
        message.avatar_file_name = (_b = object.avatar_file_name) !== null && _b !== void 0 ? _b : undefined;
        message.id = (_c = object.id) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function createBaseLabelGroup() {
    return { slug: "", labels: [] };
}
exports.LabelGroup = {
    fromJSON: function (object) {
        return {
            slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
            labels: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.labels) ? object.labels.map(function (e) { return exports.Label.fromJSON(e); }) : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.slug !== "") {
            obj.slug = message.slug;
        }
        if ((_a = message.labels) === null || _a === void 0 ? void 0 : _a.length) {
            obj.labels = message.labels.map(function (e) { return exports.Label.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.LabelGroup.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseLabelGroup();
        message.slug = (_a = object.slug) !== null && _a !== void 0 ? _a : "";
        message.labels = ((_b = object.labels) === null || _b === void 0 ? void 0 : _b.map(function (e) { return exports.Label.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseLabel() {
    return { slug: "", value_i18n: "" };
}
exports.Label = {
    fromJSON: function (object) {
        return {
            slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
            value_i18n: isSet(object.value_i18n) ? globalThis.String(object.value_i18n) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.slug !== "") {
            obj.slug = message.slug;
        }
        if (message.value_i18n !== "") {
            obj.value_i18n = message.value_i18n;
        }
        return obj;
    },
    create: function (base) {
        return exports.Label.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseLabel();
        message.slug = (_a = object.slug) !== null && _a !== void 0 ? _a : "";
        message.value_i18n = (_b = object.value_i18n) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseProjectAggregate() {
    return { contributors_count: 0 };
}
exports.ProjectAggregate = {
    fromJSON: function (object) {
        return { contributors_count: isSet(object.contributors_count) ? globalThis.Number(object.contributors_count) : 0 };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.contributors_count !== 0) {
            obj.contributors_count = Math.round(message.contributors_count);
        }
        return obj;
    },
    create: function (base) {
        return exports.ProjectAggregate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseProjectAggregate();
        message.contributors_count = (_a = object.contributors_count) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseReservation() {
    return { kind: reservation_1.ReservationKind.RESERVATION_KIND_UNSPECIFIED, values: [] };
}
exports.Reservation = {
    fromJSON: function (object) {
        return {
            kind: isSet(object.kind) ? (0, reservation_1.reservationKindFromJSON)(object.kind) : reservation_1.ReservationKind.RESERVATION_KIND_UNSPECIFIED,
            values: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.values) ? object.values.map(function (e) { return globalThis.String(e); }) : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.kind !== reservation_1.ReservationKind.RESERVATION_KIND_UNSPECIFIED) {
            obj.kind = (0, reservation_1.reservationKindToJSON)(message.kind);
        }
        if ((_a = message.values) === null || _a === void 0 ? void 0 : _a.length) {
            obj.values = message.values;
        }
        return obj;
    },
    create: function (base) {
        return exports.Reservation.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseReservation();
        message.kind = (_a = object.kind) !== null && _a !== void 0 ? _a : reservation_1.ReservationKind.RESERVATION_KIND_UNSPECIFIED;
        message.values = ((_b = object.values) === null || _b === void 0 ? void 0 : _b.map(function (e) { return e; })) || [];
        return message;
    },
};
function createBaseOrganization() {
    return { siret: "", vat_number: "" };
}
exports.Organization = {
    fromJSON: function (object) {
        return {
            siret: isSet(object.siret) ? globalThis.String(object.siret) : "",
            vat_number: isSet(object.vat_number) ? globalThis.String(object.vat_number) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.siret !== "") {
            obj.siret = message.siret;
        }
        if (message.vat_number !== "") {
            obj.vat_number = message.vat_number;
        }
        return obj;
    },
    create: function (base) {
        return exports.Organization.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseOrganization();
        message.siret = (_a = object.siret) !== null && _a !== void 0 ? _a : "";
        message.vat_number = (_b = object.vat_number) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBasePartnerLogo() {
    return { image_file_name: "", id: 0 };
}
exports.PartnerLogo = {
    fromJSON: function (object) {
        return {
            image_file_name: isSet(object.image_file_name) ? globalThis.String(object.image_file_name) : "",
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.image_file_name !== "") {
            obj.image_file_name = message.image_file_name;
        }
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        return obj;
    },
    create: function (base) {
        return exports.PartnerLogo.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBasePartnerLogo();
        message.image_file_name = (_a = object.image_file_name) !== null && _a !== void 0 ? _a : "";
        message.id = (_b = object.id) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseCommitmentPartner() {
    return {
        partner_name: "",
        partner_link: "",
        partner_image_file_name: undefined,
        partner_site: "",
        partner_url: "",
        partner_promoted: false,
        commitment_amount_spent: 0,
        commitment_active: false,
        commitment_max_amount_for_one_collect: 0,
    };
}
exports.CommitmentPartner = {
    fromJSON: function (object) {
        return {
            partner_name: isSet(object.partner_name) ? globalThis.String(object.partner_name) : "",
            partner_link: isSet(object.partner_link) ? globalThis.String(object.partner_link) : "",
            partner_image_file_name: isSet(object.partner_image_file_name)
                ? globalThis.String(object.partner_image_file_name)
                : undefined,
            partner_site: isSet(object.partner_site) ? globalThis.String(object.partner_site) : "",
            partner_url: isSet(object.partner_url) ? globalThis.String(object.partner_url) : "",
            partner_promoted: isSet(object.partner_promoted) ? globalThis.Boolean(object.partner_promoted) : false,
            commitment_amount_spent: isSet(object.commitment_amount_spent)
                ? globalThis.Number(object.commitment_amount_spent)
                : 0,
            commitment_active: isSet(object.commitment_active) ? globalThis.Boolean(object.commitment_active) : false,
            commitment_max_amount_for_one_collect: isSet(object.commitment_max_amount_for_one_collect)
                ? globalThis.Number(object.commitment_max_amount_for_one_collect)
                : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.partner_name !== "") {
            obj.partner_name = message.partner_name;
        }
        if (message.partner_link !== "") {
            obj.partner_link = message.partner_link;
        }
        if (message.partner_image_file_name !== undefined) {
            obj.partner_image_file_name = message.partner_image_file_name;
        }
        if (message.partner_site !== "") {
            obj.partner_site = message.partner_site;
        }
        if (message.partner_url !== "") {
            obj.partner_url = message.partner_url;
        }
        if (message.partner_promoted !== false) {
            obj.partner_promoted = message.partner_promoted;
        }
        if (message.commitment_amount_spent !== 0) {
            obj.commitment_amount_spent = Math.round(message.commitment_amount_spent);
        }
        if (message.commitment_active !== false) {
            obj.commitment_active = message.commitment_active;
        }
        if (message.commitment_max_amount_for_one_collect !== 0) {
            obj.commitment_max_amount_for_one_collect = Math.round(message.commitment_max_amount_for_one_collect);
        }
        return obj;
    },
    create: function (base) {
        return exports.CommitmentPartner.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var message = createBaseCommitmentPartner();
        message.partner_name = (_a = object.partner_name) !== null && _a !== void 0 ? _a : "";
        message.partner_link = (_b = object.partner_link) !== null && _b !== void 0 ? _b : "";
        message.partner_image_file_name = (_c = object.partner_image_file_name) !== null && _c !== void 0 ? _c : undefined;
        message.partner_site = (_d = object.partner_site) !== null && _d !== void 0 ? _d : "";
        message.partner_url = (_e = object.partner_url) !== null && _e !== void 0 ? _e : "";
        message.partner_promoted = (_f = object.partner_promoted) !== null && _f !== void 0 ? _f : false;
        message.commitment_amount_spent = (_g = object.commitment_amount_spent) !== null && _g !== void 0 ? _g : 0;
        message.commitment_active = (_h = object.commitment_active) !== null && _h !== void 0 ? _h : false;
        message.commitment_max_amount_for_one_collect = (_j = object.commitment_max_amount_for_one_collect) !== null && _j !== void 0 ? _j : 0;
        return message;
    },
};
function createBaseAsset() {
    return { name: "", file_key: "" };
}
exports.Asset = {
    fromJSON: function (object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            file_key: isSet(object.file_key) ? globalThis.String(object.file_key) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.file_key !== "") {
            obj.file_key = message.file_key;
        }
        return obj;
    },
    create: function (base) {
        return exports.Asset.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAsset();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.file_key = (_b = object.file_key) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseFetchProjectRequest() {
    return { slug: undefined, preview_uuid: undefined, locale: "", user_id: undefined };
}
exports.FetchProjectRequest = {
    fromJSON: function (object) {
        return {
            slug: isSet(object.slug) ? globalThis.String(object.slug) : undefined,
            preview_uuid: isSet(object.preview_uuid) ? globalThis.String(object.preview_uuid) : undefined,
            locale: isSet(object.locale) ? globalThis.String(object.locale) : "",
            user_id: isSet(object.user_id) ? globalThis.Number(object.user_id) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.slug !== undefined) {
            obj.slug = message.slug;
        }
        if (message.preview_uuid !== undefined) {
            obj.preview_uuid = message.preview_uuid;
        }
        if (message.locale !== "") {
            obj.locale = message.locale;
        }
        if (message.user_id !== undefined) {
            obj.user_id = Math.round(message.user_id);
        }
        return obj;
    },
    create: function (base) {
        return exports.FetchProjectRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseFetchProjectRequest();
        message.slug = (_a = object.slug) !== null && _a !== void 0 ? _a : undefined;
        message.preview_uuid = (_b = object.preview_uuid) !== null && _b !== void 0 ? _b : undefined;
        message.locale = (_c = object.locale) !== null && _c !== void 0 ? _c : "";
        message.user_id = (_d = object.user_id) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function createBaseFetchProjectResponse() {
    return {
        project: undefined,
        collect: undefined,
        description: undefined,
        owner: undefined,
        rewards: [],
        label_groups: [],
        project_aggregate: undefined,
        reservations: [],
        reservation_open_for_user: false,
        organization: undefined,
        partner_logos: [],
        regional_code: undefined,
        assets: [],
        product_kinds: [],
        commitment_partners: [],
    };
}
exports.FetchProjectResponse = {
    fromJSON: function (object) {
        return {
            project: isSet(object.project) ? exports.Project.fromJSON(object.project) : undefined,
            collect: isSet(object.collect) ? exports.Collect.fromJSON(object.collect) : undefined,
            description: isSet(object.description) ? exports.Description.fromJSON(object.description) : undefined,
            owner: isSet(object.owner) ? exports.Owner.fromJSON(object.owner) : undefined,
            rewards: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map(function (e) { return exports.Reward.fromJSON(e); }) : [],
            label_groups: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.label_groups)
                ? object.label_groups.map(function (e) { return exports.LabelGroup.fromJSON(e); })
                : [],
            project_aggregate: isSet(object.project_aggregate)
                ? exports.ProjectAggregate.fromJSON(object.project_aggregate)
                : undefined,
            reservations: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.reservations)
                ? object.reservations.map(function (e) { return exports.Reservation.fromJSON(e); })
                : [],
            reservation_open_for_user: isSet(object.reservation_open_for_user)
                ? globalThis.Boolean(object.reservation_open_for_user)
                : false,
            organization: isSet(object.organization) ? exports.Organization.fromJSON(object.organization) : undefined,
            partner_logos: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.partner_logos)
                ? object.partner_logos.map(function (e) { return exports.PartnerLogo.fromJSON(e); })
                : [],
            regional_code: isSet(object.regional_code) ? globalThis.String(object.regional_code) : undefined,
            assets: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.assets)
                ? object.assets.map(function (e) { return exports.Asset.fromJSON(e); })
                : [],
            product_kinds: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.product_kinds)
                ? object.product_kinds.map(function (e) { return (0, product_kind_1.productKindFromJSON)(e); })
                : [],
            commitment_partners: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.commitment_partners)
                ? object.commitment_partners.map(function (e) { return exports.CommitmentPartner.fromJSON(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a, _b, _c, _d, _e, _f, _g;
        var obj = {};
        if (message.project !== undefined) {
            obj.project = exports.Project.toJSON(message.project);
        }
        if (message.collect !== undefined) {
            obj.collect = exports.Collect.toJSON(message.collect);
        }
        if (message.description !== undefined) {
            obj.description = exports.Description.toJSON(message.description);
        }
        if (message.owner !== undefined) {
            obj.owner = exports.Owner.toJSON(message.owner);
        }
        if ((_a = message.rewards) === null || _a === void 0 ? void 0 : _a.length) {
            obj.rewards = message.rewards.map(function (e) { return exports.Reward.toJSON(e); });
        }
        if ((_b = message.label_groups) === null || _b === void 0 ? void 0 : _b.length) {
            obj.label_groups = message.label_groups.map(function (e) { return exports.LabelGroup.toJSON(e); });
        }
        if (message.project_aggregate !== undefined) {
            obj.project_aggregate = exports.ProjectAggregate.toJSON(message.project_aggregate);
        }
        if ((_c = message.reservations) === null || _c === void 0 ? void 0 : _c.length) {
            obj.reservations = message.reservations.map(function (e) { return exports.Reservation.toJSON(e); });
        }
        if (message.reservation_open_for_user !== false) {
            obj.reservation_open_for_user = message.reservation_open_for_user;
        }
        if (message.organization !== undefined) {
            obj.organization = exports.Organization.toJSON(message.organization);
        }
        if ((_d = message.partner_logos) === null || _d === void 0 ? void 0 : _d.length) {
            obj.partner_logos = message.partner_logos.map(function (e) { return exports.PartnerLogo.toJSON(e); });
        }
        if (message.regional_code !== undefined) {
            obj.regional_code = message.regional_code;
        }
        if ((_e = message.assets) === null || _e === void 0 ? void 0 : _e.length) {
            obj.assets = message.assets.map(function (e) { return exports.Asset.toJSON(e); });
        }
        if ((_f = message.product_kinds) === null || _f === void 0 ? void 0 : _f.length) {
            obj.product_kinds = message.product_kinds.map(function (e) { return (0, product_kind_1.productKindToJSON)(e); });
        }
        if ((_g = message.commitment_partners) === null || _g === void 0 ? void 0 : _g.length) {
            obj.commitment_partners = message.commitment_partners.map(function (e) { return exports.CommitmentPartner.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.FetchProjectResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var message = createBaseFetchProjectResponse();
        message.project = (object.project !== undefined && object.project !== null)
            ? exports.Project.fromPartial(object.project)
            : undefined;
        message.collect = (object.collect !== undefined && object.collect !== null)
            ? exports.Collect.fromPartial(object.collect)
            : undefined;
        message.description = (object.description !== undefined && object.description !== null)
            ? exports.Description.fromPartial(object.description)
            : undefined;
        message.owner = (object.owner !== undefined && object.owner !== null) ? exports.Owner.fromPartial(object.owner) : undefined;
        message.rewards = ((_a = object.rewards) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.Reward.fromPartial(e); })) || [];
        message.label_groups = ((_b = object.label_groups) === null || _b === void 0 ? void 0 : _b.map(function (e) { return exports.LabelGroup.fromPartial(e); })) || [];
        message.project_aggregate = (object.project_aggregate !== undefined && object.project_aggregate !== null)
            ? exports.ProjectAggregate.fromPartial(object.project_aggregate)
            : undefined;
        message.reservations = ((_c = object.reservations) === null || _c === void 0 ? void 0 : _c.map(function (e) { return exports.Reservation.fromPartial(e); })) || [];
        message.reservation_open_for_user = (_d = object.reservation_open_for_user) !== null && _d !== void 0 ? _d : false;
        message.organization = (object.organization !== undefined && object.organization !== null)
            ? exports.Organization.fromPartial(object.organization)
            : undefined;
        message.partner_logos = ((_e = object.partner_logos) === null || _e === void 0 ? void 0 : _e.map(function (e) { return exports.PartnerLogo.fromPartial(e); })) || [];
        message.regional_code = (_f = object.regional_code) !== null && _f !== void 0 ? _f : undefined;
        message.assets = ((_g = object.assets) === null || _g === void 0 ? void 0 : _g.map(function (e) { return exports.Asset.fromPartial(e); })) || [];
        message.product_kinds = ((_h = object.product_kinds) === null || _h === void 0 ? void 0 : _h.map(function (e) { return e; })) || [];
        message.commitment_partners = ((_j = object.commitment_partners) === null || _j === void 0 ? void 0 : _j.map(function (e) { return exports.CommitmentPartner.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseEnrichSalesforceDataOrganizationEvent() {
    return { salesforce_id: "", organization_id: 0, project_id: 0 };
}
exports.EnrichSalesforceDataOrganizationEvent = {
    fromJSON: function (object) {
        return {
            salesforce_id: isSet(object.salesforce_id) ? globalThis.String(object.salesforce_id) : "",
            organization_id: isSet(object.organization_id) ? globalThis.Number(object.organization_id) : 0,
            project_id: isSet(object.project_id) ? globalThis.Number(object.project_id) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.salesforce_id !== "") {
            obj.salesforce_id = message.salesforce_id;
        }
        if (message.organization_id !== 0) {
            obj.organization_id = Math.round(message.organization_id);
        }
        if (message.project_id !== 0) {
            obj.project_id = Math.round(message.project_id);
        }
        return obj;
    },
    create: function (base) {
        return exports.EnrichSalesforceDataOrganizationEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseEnrichSalesforceDataOrganizationEvent();
        message.salesforce_id = (_a = object.salesforce_id) !== null && _a !== void 0 ? _a : "";
        message.organization_id = (_b = object.organization_id) !== null && _b !== void 0 ? _b : 0;
        message.project_id = (_c = object.project_id) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
function handleRequest(url, requestBody, fromJSON, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var response, responseBody, parseError_1, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, , 8]);
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] request:\n', JSON.stringify(requestBody));
                    }
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            body: JSON.stringify(requestBody),
                            headers: __assign(__assign({ 'Content-Type': 'application/json' }, ((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : {})), ((options === null || options === void 0 ? void 0 : options.user_id) ? { 'X-Jwt-Payload-B64': options.user_id } : {}))
                        })];
                case 1:
                    response = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] response:\n', JSON.stringify(response));
                    }
                    responseBody = void 0;
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 6]);
                    return [4 /*yield*/, response.json()];
                case 3:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 4:
                    parseError_1 = _b.sent();
                    return [4 /*yield*/, response.text()];
                case 5:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (!response.ok) {
                        throw {
                            statusText: response.statusText || 'HTTP Error',
                            body: responseBody
                        };
                    }
                    return [2 /*return*/, fromJSON(responseBody)];
                case 7:
                    error_1 = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.error('[CLIENT DEBUG] error:\n', JSON.stringify(error_1));
                    }
                    if (error_1.statusText) {
                        // This is our custom error object from above
                        throw error_1;
                    }
                    else {
                        // This could be a network error or other fetch-related error
                        throw {
                            statusText: 'Network Error',
                            body: error_1.message || 'An unknown error occurred',
                            error: error_1,
                        };
                    }
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
var ProjectsServiceClient = /** @class */ (function () {
    function ProjectsServiceClient(fetcher, baseURL) {
        this.fetcher = fetcher;
        this.baseURL = baseURL;
    }
    ProjectsServiceClient.prototype.Health = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = health_1.HealthRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.projects.v1.ProjectsService/Health";
                return [2 /*return*/, handleRequest(url, jsonReq, health_1.HealthResponse.fromJSON, options)];
            });
        });
    };
    ProjectsServiceClient.prototype.FetchProject = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.FetchProjectRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.projects.v1.ProjectsService/FetchProject";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.FetchProjectResponse.fromJSON, options)];
            });
        });
    };
    return ProjectsServiceClient;
}());
exports.ProjectsServiceClient = ProjectsServiceClient;
//# sourceMappingURL=projects.js.map